"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleMakeModelQuery = void 0;
exports.vehicleMakeModelQuery = `
    query getBisnodeVehicleByLicenceNo($licenceNo: String!) {
        getBisnodeVehicleByLicenceNo(licenceNo: $licenceNo) {
            brandtext
            model
        }
    }
`;
//# sourceMappingURL=vehicleMakeModelQuery.js.map